"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuBanner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const useKitExperimentBanner_1 = require("./useKitExperimentBanner");
var BannerType;
(function (BannerType) {
    BannerType["MENU"] = "menu";
    BannerType["HOME"] = "home";
})(BannerType || (BannerType = {}));
/**
 * @component
 * @name MenuBanner
 * @description
 * O componente `MenuBanner` exibe uma imagem de banner dentro do menu, que direciona para uma URL de catálogo especificada.
 * Ele busca a imagem do banner dinamicamente com base em uma configuração de feature flag.
 *
 * @param {string} props.catalogUrl - A URL para a qual a imagem do banner direciona.
 *
 */
const MenuBanner = ({ catalogUrl, type, config }) => {
    const typeParsed = type || BannerType.MENU;
    const { bannerImage } = (0, useKitExperimentBanner_1.useKitExperimentBanner)({ type: typeParsed });
    if (!bannerImage) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("a", Object.assign({ href: catalogUrl, target: "_blank", rel: "noopener noreferrer" }, { children: (0, jsx_runtime_1.jsx)(flora_react_1.Image, { "data-testid": `banner-kit-natal-${typeParsed}`, src: bannerImage, alt: "Imagem de banner direcionando para o cat\u00E1logo", fit: "fill", css: Object.assign({}, config) }) })));
};
exports.MenuBanner = MenuBanner;
